// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import { DAMAGE_CASE_TOGGLE_COPY_TO } from "./constants"

export function toggleCopyTo(caseId, code) {
  return {
    type: DAMAGE_CASE_TOGGLE_COPY_TO,
    data: { caseId, code },
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case DAMAGE_CASE_TOGGLE_COPY_TO:
      const { caseId, code } = action.data
      const damageCase = state.unsentCases[caseId]
      const copiesToContactAddressCodes = damageCase.copiesToContactAddressCodes.filter(c => c !== code)
      if (copiesToContactAddressCodes.length === damageCase.copiesToContactAddressCodes.length)
        copiesToContactAddressCodes.push(code)
      const alteredCase = { ...damageCase, copiesToContactAddressCodes }
      return {
        ...state,
        unsentCases: { ...state.unsentCases, [caseId]: alteredCase },
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/features/damage-case/redux/toggleCopyTo.js